module.exports = __webpack_public_path__ + "static/gallery_13-thumb-508cd1b610d37399dcc5c24c9e2ca100.jpg";